interface commentTypes {
  description: string;
  wallpaperId: string;
}

async function addNewComment(comment: commentTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/comments`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(comment),
    credentials: "include",
  });
  const result = await response.json();

  return result;
}

export default addNewComment;
